<script>
	export let active;
	export let name;
	const svgLib = {
		Jobs: {
			svg: `<path
		d="M8.94466 5.05566H7.83355C6.60577 5.05566 5.61133 6.05011 5.61133 7.27789V17.8334C5.61133 19.0612 6.60577 20.0557 7.83355 20.0557H16.1669C17.3947 20.0557 18.3891 19.0612 18.3891 17.8334V7.27789C18.3891 6.05011 17.3947 5.05566 16.1669 5.05566H15.0558"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M13.9443 3.38892H10.0554C9.4418 3.38892 8.94434 3.88638 8.94434 4.50003V5.61114C8.94434 6.22479 9.4418 6.72225 10.0554 6.72225H13.9443C14.558 6.72225 15.0554 6.22479 15.0554 5.61114V4.50003C15.0554 3.88638 14.558 3.38892 13.9443 3.38892Z"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M8.94434 15.0557H11.7221"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M8.94434 11.7222H11.7221"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M14.5 15.0557H15.0556"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M14.5 11.7222H15.0556"
		stroke="#1E1E1E"
		stroke-width="1.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>`,
		},
		Dashboard: {
			svg: `<path
						d="M10.611 5.05566H5.05545C4.4418 5.05566 3.94434 5.55313 3.94434 6.16678V10.0557C3.94434 10.6693 4.4418 11.1668 5.05545 11.1668H10.611C11.2247 11.1668 11.7221 10.6693 11.7221 10.0557V6.16678C11.7221 5.55313 11.2247 5.05566 10.611 5.05566Z"
						stroke="#1E1E1E"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M18.9447 7.27783H16.7224C16.1088 7.27783 15.6113 7.77529 15.6113 8.38894V15.6112C15.6113 16.2248 16.1088 16.7223 16.7224 16.7223H18.9447C19.5583 16.7223 20.0558 16.2248 20.0558 15.6112V8.38894C20.0558 7.77529 19.5583 7.27783 18.9447 7.27783Z"
						stroke="#1E1E1E"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M11.167 14.5H7.2781C6.66445 14.5 6.16699 14.9975 6.16699 15.6111V17.8333C6.16699 18.447 6.66445 18.9444 7.2781 18.9444H11.167C11.7806 18.9444 12.2781 18.447 12.2781 17.8333V15.6111C12.2781 14.9975 11.7806 14.5 11.167 14.5Z"
						stroke="#1E1E1E"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>`,
		},
		Cars: {
			svg: `<path d="M3.94434 16.7224V18.3891C3.94434 18.6957 4.19322 18.9446 4.49989 18.9446H5.611C5.91767 18.9446 6.16656 18.6957 6.16656 18.3891V16.7224H3.94434Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.834 16.7224V18.3891C17.834 18.6957 18.0829 18.9446 18.3895 18.9446H19.5007C19.8073 18.9446 20.0562 18.6957 20.0562 18.3891V16.7224H17.834Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.72298 14.2223C7.18322 14.2223 7.55631 13.8492 7.55631 13.389C7.55631 12.9288 7.18322 12.5557 6.72298 12.5557C6.26274 12.5557 5.88965 12.9288 5.88965 13.389C5.88965 13.8492 6.26274 14.2223 6.72298 14.2223Z" fill="#1E1E1E"/>
<path d="M17.2777 14.2223C17.7379 14.2223 18.111 13.8492 18.111 13.389C18.111 12.9288 17.7379 12.5557 17.2777 12.5557C16.8174 12.5557 16.4443 12.9288 16.4443 13.389C16.4443 13.8492 16.8174 14.2223 17.2777 14.2223Z" fill="#1E1E1E"/>
<path d="M15.3466 5.05566H8.65322C7.67211 5.05566 6.80656 5.699 6.52434 6.639L5.33322 10.6112L4.59545 11.349C4.17878 11.7657 3.94434 12.3312 3.94434 12.9201V16.7223H20.0554V12.9201C20.0554 12.3312 19.821 11.7657 19.4043 11.349L18.6666 10.6112L17.4754 6.639C17.1932 5.699 16.3288 5.05566 15.3466 5.05566Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.66699 10.6113H20.3337" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.334 13.9446H13.6673" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		"EV Lots": {
			svg: `<path d="M5.05566 19.5V6.72222C5.05566 5.49444 6.05011 4.5 7.27789 4.5H12.2779C13.5057 4.5 14.5001 5.49444 14.5001 6.72222V19.5" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.38867 19.5H16.1664" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.1663 7.27783V8.9445C21.1663 9.8645 20.4197 10.6112 19.4997 10.6112C18.5797 10.6112 17.833 9.8645 17.833 8.9445V7.27783" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9324 11.1789C11.8346 11 11.6479 10.8889 11.4446 10.8889H10.2201L10.8046 8.81775C10.879 8.55331 10.749 8.27442 10.499 8.16108C10.249 8.04775 9.95236 8.13442 9.80347 8.36553L7.64569 11.6989C7.53569 11.87 7.5268 12.0877 7.62347 12.2666C7.72125 12.4455 7.90791 12.5566 8.11125 12.5566H9.33569L8.75125 14.6277C8.6768 14.8922 8.8068 15.1711 9.0568 15.2844C9.13013 15.3178 9.20902 15.3333 9.28569 15.3333C9.46902 15.3333 9.6468 15.2422 9.75236 15.08L11.9101 11.7466C12.0201 11.5755 12.029 11.3577 11.9324 11.1789Z" fill="#1E1E1E"/>
<path d="M17.2773 16.6155C17.4518 16.6789 17.6362 16.7222 17.8329 16.7222C18.7529 16.7222 19.4996 15.9755 19.4996 15.0555V10.6111" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		"Car parks": {
			svg: `<path d="M17.3933 4H6.55111C5.14217 4 4 5.14217 4 6.55111V17.3933C4 18.8023 5.14217 19.9445 6.55111 19.9445H17.3933C18.8023 19.9445 19.9445 18.8023 19.9445 17.3933V6.55111C19.9445 5.14217 18.8023 4 17.3933 4Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.74023 16.1178V7.82666" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.74023 12.2911H12.6102C13.8424 12.2911 14.8425 11.2911 14.8425 10.0589C14.8425 8.82542 13.8424 7.82666 12.6102 7.82666H9.74023" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		Blackout: {
			svg: `<path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" stroke="#1E1E1E" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M15.1998 12H8.7998" stroke="#1E1E1E" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/>
`,
		},
		"Fuel Card": {
			svg: `<path d="M3.94434 10.0557H20.0554" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.16678 17.8335H17.8334C19.0607 17.8335 20.0557 16.8386 20.0557 15.6113V8.38905C20.0557 7.16175 19.0607 6.16683 17.8334 6.16683L6.16678 6.16683C4.93948 6.16683 3.94455 7.16175 3.94455 8.38905V15.6113C3.94455 16.8386 4.93948 17.8335 6.16678 17.8335Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.72168 14.5H10.055" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.167 14.5H17.2781" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		Issues: {
			svg: `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.4964 13.5664C11.4767 15.2081 9.65689 16.3018 7.58158 16.3018C4.38942 16.3018 1.80078 13.7132 1.80078 10.521C1.80078 7.32888 4.38942 4.74023 7.58158 4.74023C7.6787 4.74023 7.77466 4.74255 7.87062 4.74717" stroke="#00071F" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.1305 18.943L11.7305 14.543" stroke="#00071F" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5413 10.1294H17.0419C17.953 10.1294 18.5068 9.12469 18.0189 8.35468L14.6279 3.00051C14.1735 2.28369 13.1283 2.28369 12.674 3.00051L9.28295 8.35468C8.79505 9.12469 9.34885 10.1294 10.2599 10.1294H10.7605" stroke="#00071F" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.6523 5.89648V8.20881" stroke="#00071F" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.843 11.0995C13.843 11.2049 13.7576 11.2903 13.6523 11.2903C13.5469 11.2903 13.4615 11.2049 13.4615 11.0995C13.4615 10.9942 13.5469 10.9088 13.6523 10.9088C13.7576 10.9088 13.843 10.9942 13.843 11.0995Z" fill="#00071F" stroke="#00071F" stroke-width="1.35271"/>
</svg>
`,
		},
		"Master Data": {
			svg: `<path d="M12.0001 9.22217C15.8354 9.22217 18.9446 8.10288 18.9446 6.72217C18.9446 5.34146 15.8354 4.22217 12.0001 4.22217C8.1648 4.22217 5.05566 5.34146 5.05566 6.72217C5.05566 8.10288 8.1648 9.22217 12.0001 9.22217Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.05566 6.72217V17.2777C5.05566 18.6588 8.16455 19.7777 12.0001 19.7777C15.8357 19.7777 18.9446 18.6588 18.9446 17.2777V6.72217" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.05566 12C5.05566 13.3811 8.16455 14.5 12.0001 14.5C15.8357 14.5 18.9446 13.3811 18.9446 12" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		Account: {
			svg: `<path d="M11.9996 12.8331C13.2269 12.8331 14.2218 11.8382 14.2218 10.6109C14.2218 9.38359 13.2269 8.38867 11.9996 8.38867C10.7723 8.38867 9.77734 9.38359 9.77734 10.6109C9.77734 11.8382 10.7723 12.8331 11.9996 12.8331Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.72656 18.83C8.25878 16.9711 9.9699 15.6111 11.9999 15.6111C14.0299 15.6111 15.741 16.9711 16.2732 18.83" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9999 20.0554C16.4489 20.0554 20.0554 16.4489 20.0554 11.9999C20.0554 7.55094 16.4489 3.94434 11.9999 3.94434C7.55094 3.94434 3.94434 7.55094 3.94434 11.9999C3.94434 16.4489 7.55094 20.0554 11.9999 20.0554Z" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
`,
		},
		Servicing: {
			svg: `<path d="M15.0557 20.0555V17.1178C17.3568 15.9866 18.9446 13.6255 18.9446 10.8889C18.9446 7.93664 17.099 5.41997 14.5001 4.41553V10.0555C14.5001 10.6689 14.0023 11.1666 13.389 11.1666H10.6112C9.99789 11.1666 9.50011 10.6689 9.50011 10.0555V4.41553C6.90122 5.41997 5.05566 7.93553 5.05566 10.8889C5.05566 13.6255 6.64344 15.9866 8.94455 17.1178V20.0555" stroke="#1E1E1E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>`,
		},
	};

	// Maintenance & Repair reuses the Servicing icon — same wrench glyph,
	// no need for a dedicated one (FRNT-5901).
	svgLib["Maintenance & Repairs"] = svgLib.Servicing;
</script>

<svg
	width="20"
	height="20"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={active ? "active" : ""}
>
	{@html svgLib[name]?.svg}
</svg>
